<template>
  <div class="container">
    <div class="bg"></div>
    <div class="content min-width">
      <el-carousel trigger="click" height="312px">
        <el-carousel-item v-for="item in urls" :key="item.id">
          <img class="slider-img" :src="fileUrl + item.imghref" alt=""  @click="goToArticleDetail(item, 'advertising')">
        </el-carousel-item>
      </el-carousel>
      <div class="mes">
        <div class="left">
          <div class="left-title">
            <span>动态资讯</span>
            <div class="more" v-if="informationList.length > 0" @click="goToArticleList(0)">
              <span>更多</span>
              <i class="arrow"></i>
            </div>
          </div>
          <div class="list-box">
            <div class="list-item" v-for="item in informationList" :key="item.id" @click="goToArticleDetail(item, 'Information')">
              <div class="sub-title">{{item.title}}</div>
              <div class="time">{{item.publishdate}}</div>
            </div>
            <empty v-if="informationList && informationList.length == 0" />
          </div>
        </div>
        <div class="right">
          <div class="right-title">
            <div class="text">
              <i class="download-icon"></i>
              <span>最多下载</span>
            </div>
            <div class="more" v-if="mostDownloadsThesis.length > 0" @click="goToPaperList('downloads')">
              <span>更多</span>
              <i class="arrow"></i>
            </div>
          </div>
          <div class="list-box">
            <div class="list-item" v-for="(item, index) in mostDownloadsThesis" :key="index" @click="goToPaperDetail(item)">
              <span class="num">{{index + 1}}</span>
              <span class="title">{{item.thesisname}}</span>
            </div>
            <empty v-if="mostDownloadsThesis.length == 0" />
          </div>
        </div>
      </div>
      <div class="mes">
        <div class="left">
          <div class="left-title">
            <span>政策法规</span>
            <div class="more" v-if="regulationsList.length > 0" @click="goToArticleList(1)">
              <span>更多</span>
              <i class="arrow"></i>
            </div>
          </div>
          <div class="list-box">
            <div class="list-item" v-for="item in regulationsList" :key="item.id" @click="goToArticleDetail(item, 'regulations')">
              <div class="sub-title">{{item.title}}</div>
              <div class="time">{{item.publishdate}}</div>
            </div>
            <empty v-if="regulationsList.length == 0" />
          </div>
        </div>
        <div class="right">
          <div class="right-title">
            <div class="text">
              <i class="show-icon"></i>
              <span>最多查看</span>
            </div>
            <div class="more" v-if="mostShowThesis.length > 0" @click="goToPaperList('browses')">
              <span>更多</span>
              <i class="arrow"></i>
            </div>
          </div>
          <div class="list-box">
            <div class="list-item" v-for="(item, index) in mostShowThesis" :key="index" @click="goToPaperDetail(item)">
              <span class="num">{{index + 1}}</span>
              <span class="title">{{item.thesisname}}</span>
            </div>
            <empty v-if="mostShowThesis.length == 0" />
          </div>
        </div>
      </div>
      <div class="trend">
        <div class="left">
          <div class="year-box">
            <div class="title">选择年份</div>
            <div 
              class="year" 
              :class="{'active': index == yearIndex}" 
              v-for="(item, index) in yearList" 
              :key="index"
              @click="handleYearClick(index)"
            >{{item}} 年</div>
          </div>
          <div class="keyword-box">
            <div class="title">关键词</div>
            <div 
              class="keyword-item" 
              :class="{'active': index == keywordIndex}" 
              v-for="(item, index) in keywordList" 
              :key="item.id"
              @click="handleKeywordClick(index)"
            >
              <div class="sort">
                <div class="one" v-if="index == 0"></div>
                <div class="two" v-if="index == 1"></div>
                <div class="three" v-if="index == 2"></div>
                <div class="num" v-if="index > 2">{{index + 1}}</div>
              </div>
              <div class="text">{{item.keywordname}}</div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="top">
            <div class="title">研究趋势</div>
            <div class="tip" v-if="keywordList.length > 0">
              <i class="icon"></i>
              <span v-if="yearList.length > 0 && keywordList.length > 0">{{yearList[yearIndex]}} 年 / {{keywordList[keywordIndex].keywordname}}</span>
            </div>
          </div>
          <div class="trend-mes">
            <div class="mes-item" v-for="(item, index) in trendList" :key="index" @click="goToPaperDetail(item)">{{item.thesisname}}</div>
            <empty v-if="trendList.length == 0" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible" :lockScroll="false" top="25vh">
      <div name="title">
        <span class="title">{{article.title}}</span>
        <span class="time">发布时间：{{(article.publishdate || article.createdtime) | YMD}}</span>
      </div>
      <div style='white-space: pre-wrap;' v-html="article.content"></div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    fileUrl,
    getBannerList, 
    getInformation, 
    getRegulations, 
    getKeywords,
    getThesisByYearAndKeyword,
    getThesisByListingTime,
    getOrderDetailByOrderNum
  } from '@/api/urls'
  import moment from 'moment'
  import empty from '@/components/EmptyData'
  import { getUrlKey } from '@/utils/utils'
  export default {
    components: {
      empty
    },
    data() {
      return {
        fileUrl: fileUrl,
        urls: [],
        banner: [
          {
            seqId: 0,
            imghref: require('../../assets/images/banner/banner_01.jpg')
          },
          {
            seqId: 1,
            imghref: require('../../assets/images/banner/banner_02.jpg')
          },
          {
            seqId: 2,
            imghref: require('../../assets/images/banner/banner_03.jpg')
          }
        ],
        informationList: [],
        regulationsList:[],
        yearList: [],
        yearIndex: 0,
        keywordList: [],
        keywordIndex: 0,
        trendList: [],
        mostDownloadsThesis: [],
        mostShowThesis: [],
        dialogVisible: false,
        article: {}
      }
    },
    async mounted() {
      await this.init()
      this.getBannerList()
      this.getInformationList()
      this.getRegulationsList()
      this.getThesisListByYearAndKeyword()
      this.getThesisList()
    },
    methods: {
      init() {
        return new Promise((resolve, reject) => {
          const orderNum = getUrlKey('out_trade_no')
          if(!orderNum) {
            resolve()
            return
          }
          getOrderDetailByOrderNum({orderNum: orderNum})
            .then(res => {
              window.location.href = '/#/paper-detail?paperId=' + res.thesisId
            })
        })
      },
      getBannerList() {
        getBannerList()
          .then(res => {
            this.urls = res
            if(this.urls.length == 0) {
              this.urls.push({ type: -1,  imghref: require('../../assets/images/default_banner.png')})
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      getInformationList() {
        getInformation({pageNum: 1, pageSize: 10})
          .then(res => {
            this.informationList = res.list
          })
          .catch(err => {
            console.log(err)
          })
      },
      getRegulationsList() {
        getRegulations({pageNum: 1, pageSize: 10})
          .then(res => {
            this.regulationsList = res.list
          })
      },
      getKeywordList() {
        return new Promise((resolve, reject) => {
          getKeywords()
            .then(res => {
              this.keywordList = res
              resolve()
            })
            .catch(err => {
              console.log(err)
            })
        })
      },
      getYearList() {
        let yearStr = moment().year()
        for(let i = 10; i > 0; i--) {
          this.yearList.push(yearStr)
          yearStr = yearStr - 1
        }
      },
      async getThesisListByYearAndKeyword() {
        await this.getKeywordList()
        this.getYearList()
        if(this.keywordList.length == 0) return
        getThesisByYearAndKeyword({
          publishYear: this.yearList[this.yearIndex] + '',
          keywordId: this.keywordList[this.keywordIndex].id
        })
          .then(res => {
            this.trendList = res
          })
          .catch(err => {
            console.log(err)
          })
      },
      getThesisList() {
        // 最多下载
        getThesisByListingTime({
          pageNum: 1,
          pageSize: 10,
          condition: 'downloads',
          sort: 'desc',
          religiousType: ''
        }).then(res => {
          this.mostDownloadsThesis = res.list
        })
        .catch(err => {
          console.log(err)
        })
        // 最多查看
        getThesisByListingTime({
          pageNum: 1,
          pageSize: 10,
          condition: 'browses',
          sort: 'desc',
          religiousType: ''
        }).then(res => {
          this.mostShowThesis = res.list
        })
        .catch(err => {
          console.log(err)
        })
      },
      handleYearClick(index) {
        this.yearIndex = index
        getThesisByYearAndKeyword({
          publishYear: this.yearList[this.yearIndex] + '',
          keywordId: this.keywordList[this.keywordIndex].id
        })
          .then(res => {
            this.trendList = res
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleKeywordClick(index) {
        this.keywordIndex = index
        getThesisByYearAndKeyword({
          publishYear: this.yearList[this.yearIndex] + '',
          keywordId: this.keywordList[this.keywordIndex].id
        })
          .then(res => {
            this.trendList = res
          })
          .catch(err => {
            console.log(err)
          })
      },
      goToArticleList(type) {
        this.$router.push({
          name: 'articleList',
          query: {
            type
          }
        })
      },
      goToArticleDetail(item, type) {
        if(item.type == -1) return
        // 更新浏览次数
        this.$store.dispatch('updateLookTotal', { id: item.id, area: type })
        // 轮播图含有外链
        // type: 2 外链
        if(item.type && item.type == 2) {
          window.open(item.content)
          return
        }
        this.article = item
        this.dialogVisible = true
      },
      goToPaperList(type) {
        this.$router.push({
          name: 'paperList',
          query: {
            condition: type
          }
        })
      },
      goToPaperDetail(item) {
        this.$router.push({
          name: 'paperDetail',
          query: {
            paperId: item.id
          }
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
  .container {
    background-color: #eceef3;
    padding-bottom: 60px;
    min-width: 1280px;
    .bg {
      width: 100%;
      min-width: 1280px;
      height: 468px;
      background: url('~@/assets/images/home_bg.png') no-repeat 0 0;
      background-size: 100% 100%;
    }
    .content {
      margin-top: -235px;
      .slider-img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }
      ::v-deep .el-carousel__button {
        width: 10px;
        height: 10px;
        border: none;
        border-radius: 50%;
        opacity: 1;
        background-color: #fff;
      }
      ::v-deep .is-active .el-carousel__button {
        background: #4B9CED;
      }
      .mes {
        display: flex;
        justify-content: space-between;
        margin-top: 30px;
        .left {
          width: 834px;
          height: 460px;
          box-sizing: border-box;
          background: #fff;
          .left-title {
            padding: 15px 20px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 2px solid #CFDFFC;
            font-family: Source Han Sans CN;
            &>span {
              font-size: 24px;
              font-weight: 400;
              color: #1B66E6;
            }
          }
          .list-box {
            padding: 20px;
            .list-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 15px;
              font-size: 16px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #191919;
              cursor: pointer;
              &:first-child {
                margin-top: 0;
              }
              .time {
                color: #A9A8A8;
              }
            }
          }
        }
        .right {
          width: 408px;
          height: 460px;
          background: #FFFFFF;
          padding: 18px 20px 30px;
          box-sizing: border-box;
          .right-title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .download-icon {
              display: inline-block;
              background: url('~@/assets/images/download-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 15px;
              height: 14px;
              margin-right: 12px;
            }
            .show-icon {
              display: inline-block;
              background: url('~@/assets/images/show-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 14px;
              height: 14px;
              margin-right: 12px;
            }
            .text {
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: 500;
              color: #191919;
            }
          }
          .list-box {
            margin-top: 39px;
            padding-right: 20px;
            .list-item {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-top: 15px;
              color: #191919;
              cursor: pointer;
              font-size: 16px;
              .num {
                font-size: 12px;
                font-family: NEU-F2;
                font-weight: 400;
                display: inline-block;
                width: 16px;
                height: 16px;
                text-align: center;
                line-height: 16px;
                margin-right: 8px;
                color: #5C92ED;
              }
              &:nth-child(1) .num {
                background: #1B66E6;
                border-radius: 50%;
                color: #fff;
              }
              &:nth-child(2) .num {
                background: #5C92ED;
                border-radius: 50%;
                color: #fff;
              }
              &:nth-child(3) .num {
                background: #5C92ED;
                border-radius: 50%;
                color: #fff;
              }
            }
          }
        }
      }
    }
    .more {
      font-size: 16px;
      font-weight: 300;
      color: #1B66E6;
      cursor: pointer;
      .arrow {
        display: inline-block;
        background: url('~@/assets/images/more_icon.png') no-repeat 0 0;
        background-size: 100% 100%;
        width: 12px;
        height: 10px;
        margin-left: 10px;
      }
    }
    .trend {
      height: 481px;
      background: #1B66E6;
      margin-top: 20px;
      box-sizing: border-box;
      padding: 19px 24px 16px 15px;
      display: flex;
      justify-content: space-between;
      .left {
        min-width: 335px;
        height: 100%;
        background: #fff;
        border-radius: 3px;
        display: flex;
        padding: 25px 0 20px;
        box-sizing: border-box;
        &>div {
          flex: 1;
        }
        .title {
          font-size: 15px;
          font-family: MiSans;
          font-weight: 500;
          color: #A6C4F7;
          text-align: center;
          margin-bottom: 15px
        }
        .year-box {
          border-right: 1px solid #BBD2FA;
          .year {
            text-align: center;
            padding: 7px 0;
            margin-top: 3px;
            font-size: 15px;
            font-family: MiSans;
            font-weight: 500;
            color: #4D4D4D;
            cursor: pointer;
          }
          .active {
            color: #5E94F1;
            background: #E4EEF9;
          }
        }
        .keyword-box {
          .keyword-item {
            display: flex;
            align-items: center;
            padding: 7px 0 7px 20px;
            margin-top: 3px;
            font-size: 15px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #4D4D4D;
            cursor: pointer;
            .sort {
              width: 25px;
              display: flex;
              justify-content: center;
            }
            .one {
              background: url('~@/assets/images/one-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 8px;
              height: 12px;
            }
            .two {
              background: url('~@/assets/images/two-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 8px;
              height: 12px;
            }
            .three {
              background: url('~@/assets/images/three-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 8px;
              height: 12px;
            }
            .num {
              font-size: 12px;
              font-family: NEU-F2;
              font-weight: 400;
              color: #5C92ED;
              width: 8px;
            }
            .text {
              width: 90px;
              margin-left: 8px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .active {
            color: #5E94F1;
            background: #E4EEF9;
          }
        }
      }
      .right {
        flex: 1;
        margin-left: 44px;
        padding: 13px 0 27px;
        .top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .title {
            font-size: 35px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 17px;
            opacity: 0.5;
            margin-left: 6px;
          }
          .tip {
            max-width: 200px;
            height: 28px;
            background: #0F56CF;
            border: 1px solid #FFFFFF;
            display: flex;
            padding: 0 13px 0 6px;
            align-items: center;
            box-sizing: border-box;
            .icon {
              display: inline-block;
              background: url('~@/assets/images/trend-icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              width: 14px;
              height: 14px;
              margin-right: 13px;
            }
            span {
              flex: 1;
              font-size: 16px;
              font-family: MiSans;
              font-weight: 500;
              color: #FFFFFF;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
          }
        }
        .trend-mes {
          margin-top: 23px;
          .mes-item {
            font-size: 16px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #FFFFFF;
            margin-bottom: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 812px;
            cursor: pointer;
            &::before {
              content: '·';
              margin-right: 10px;
            }
          }
        }
      }
    }
    ::v-deep .el-dialog__body {
      padding: 20px;
      .title {
        font-size: 20px;
        font-weight: bold;
        display: block;
        text-align: center;
        margin-bottom: 10px;
      }
      .time {
        margin-bottom: 20px;
        color: #ccc;
        display: block;
        text-align: center;
        margin-bottom: 10px;
      }
      img {
        width: 100%;
      }
    }
  }
</style>
